export default __webpack_public_path__ + "images/logo-dark-blue.1b43015e34267b11b5c6fc0f709afe5b.png";